import { SET_SETTINGS } from './actions';

const basket = (state = {}, action) => {
  switch (action.type) {
    case SET_SETTINGS: {
      return action.payload.settings;
    }
    default:
      return state;
  }
};

export default basket;
